<template>
    <CContainer
        fluid
        class="p-0"
    >
        <CRow alignHorizontal="center" >
            <CCol xl="6" md="12" class="mb-4">
                <CCard class="create-first-item-card text-center">
                    <CCardTitle>
                        <slot name="title">
                            <CCardText>
                                Create your ...
                            </CCardText>
                        </slot>
                    </CCardTitle>
                    <CCardSubtitle class="text-center">
                        <slot name="description">
                            <CCardText>
                                No items
                            </CCardText>
                        </slot>
                    </CCardSubtitle>
                    <CCardBody class="">
                        
                        <CCardText>        
                        </CCardText>
                        <slot name="redirect" class="">
                        </slot>
                        <CCardText>        
                        </CCardText>
                        <slot name="cleanFilter" class="">
                        </slot>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import { cilPlus } from '@coreui/icons';
import tableMixin from "~/mixins/table.js";
export default {
    name: "NoItemsContainerComponent",
    icons:{
        cilPlus
    },
    mixins: [tableMixin],
    data() {
        return {
            tables: {},
            tableNames: ""
        };
    },
    props: {
        table: {
            type: Object,
        },
        tableName:{
            default: undefined,
        }
    },
    watch: {
        table(newValue) {
            this.tables = {
                default: newValue,
            };
        },
    },
    methods: {
    },
    mounted() {
    },

}
</script>
<style lang="scss">

</style>